import { Box, Tooltip } from "@mui/material";
import React from "react";
import type { ControllerFieldState } from "react-hook-form";

type Props = {
  fieldState: ControllerFieldState;
};

export const DynamicFormErrorTooltip = (props: Props) => {
  return (
    <Box
      sx={{
        height: "0px",
        display: "flex",
        justifyContent: "end",
        width: "100%",
      }}
    >
      <Tooltip
        title={props.fieldState.error?.message || "Error"}
        open={!!props.fieldState.error}
        placement="top-end"
        arrow
      >
        <Box></Box>
      </Tooltip>
    </Box>
  );
};
